
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/hip",
      function () {
        return require("private-next-pages/cases/hip/index.tsx");
      }
    ]);
  